/**
 * MNJ announce bar — cart sync without ES modules so it always runs after the bar HTML.
 * Money formatting mirrors theme money-formatting.js for common {{amount}} templates.
 */
(function () {
  var ROOT = '[data-mnj-announce-bar]';

  var CURRENCY_DECIMALS = { BHD: 3, BIF: 0, CLP: 0, JPY: 0, KMF: 0, KRW: 0, VND: 0, XPF: 0 };
  var DEFAULT_DECIMALS = 2;

  function cartJsUrl() {
    try {
      var t = window.Theme;
      if (t && t.routes && t.routes.cart_js_url) return t.routes.cart_js_url;
    } catch (e) {}
    return '/cart.js';
  }

  function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor) {
    var roundedNumber = (moneyValue / divisor).toFixed(precision);
    var parts = roundedNumber.split('.');
    var a = parts[0] || '0';
    var b = parts[1] || '';
    a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, function (digit) {
      return digit + thousandsSeparator;
    });
    return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
  }

  function formatMoney(moneyValue, format, currency) {
    if (!format || typeof format !== 'string') {
      return '$' + (moneyValue / 100).toFixed(2);
    }
    var cur = (currency || 'USD').toUpperCase();
    var currencyPrecision = CURRENCY_DECIMALS[cur] != null ? CURRENCY_DECIMALS[cur] : DEFAULT_DECIMALS;
    var divisor = Math.pow(10, currencyPrecision);

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, placeholder) {
      if (placeholder === 'currency') return currency || 'USD';
      var thousandsSeparator = ',';
      var decimalSeparator = '.';
      var precision = currencyPrecision;
      switch (placeholder) {
        case 'amount':
          break;
        case 'amount_no_decimals':
          precision = 0;
          break;
        case 'amount_with_comma_separator':
          thousandsSeparator = '.';
          decimalSeparator = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          thousandsSeparator = '.';
          precision = 0;
          break;
        case 'amount_no_decimals_with_space_separator':
          thousandsSeparator = ' ';
          precision = 0;
          break;
        case 'amount_with_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousandsSeparator = "'";
          decimalSeparator = '.';
          break;
        default:
          break;
      }
      return formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor);
    });
  }

  function syncFromCart(root) {
    if (root.dataset.mnjAnnounceMode === 'static') return;

    var thresholdCents = Number(root.dataset.thresholdCents || '4900');
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var currency = root.dataset.currency || 'USD';

    var qualifiedEl = root.querySelector('[data-mnj-announce-qualified]');
    var progressEl = root.querySelector('[data-mnj-announce-progress]');
    var remainingStrong = root.querySelector('[data-mnj-announce-remaining]');
    var fillEl = root.querySelector('[data-mnj-announce-fill]');
    var comboPromo = root.querySelector('[data-mnj-announce-combo-promo]');
    var ctaShop = root.querySelector('[data-mnj-announce-cta-shop]');
    var ctaBag = root.querySelector('[data-mnj-announce-cta-bag]');

    if (!qualifiedEl || !progressEl || !remainingStrong || !fillEl) return;

    function applyQualifiedState(isQualified) {
      qualifiedEl.hidden = !isQualified;
      progressEl.hidden = isQualified;
      if (comboPromo) comboPromo.hidden = isQualified;
      if (ctaShop && ctaBag) {
        ctaShop.hidden = isQualified;
        ctaBag.hidden = !isQualified;
      } else if (ctaShop && !ctaBag) {
        ctaShop.hidden = isQualified;
      } else if (!ctaShop && ctaBag) {
        ctaBag.hidden = !isQualified;
      }
    }

    fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return;
        var total = typeof cart.total_price === 'number' ? cart.total_price : 0;

        if (thresholdCents <= 0) {
          applyQualifiedState(true);
          return;
        }

        var remaining = Math.max(0, thresholdCents - total);
        var pct = Math.min(100, Math.round((total / thresholdCents) * 100));

        if (remaining === 0) {
          applyQualifiedState(true);
        } else {
          applyQualifiedState(false);
          remainingStrong.textContent = formatMoney(remaining, moneyFormat, currency);
          fillEl.style.width = pct + '%';
        }
      })
      .catch(function () {});
  }

  function initCarousel(root) {
    var slides = root.querySelectorAll('[data-mnj-announce-slide]');
    var prev = root.querySelector('[data-mnj-announce-prev]');
    var next = root.querySelector('[data-mnj-announce-next]');
    if (slides.length < 2 || !prev || !next) return;

    var i = 0;
    function show(idx) {
      slides.forEach(function (el, j) {
        el.hidden = j !== idx;
      });
    }

    prev.addEventListener('click', function () {
      i = (i - 1 + slides.length) % slides.length;
      show(i);
    });
    next.addEventListener('click', function () {
      i = (i + 1) % slides.length;
      show(i);
    });
  }

  function init() {
    var root = document.querySelector(ROOT);
    if (!root) return;

    if (root.dataset.mnjAnnounceMode !== 'static') {
      syncFromCart(root);
      document.addEventListener('cart:update', function () {
        syncFromCart(root);
      });
    }

    initCarousel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
